import {Button, Space, Table, Tag} from "antd";
import {CSVLink} from "react-csv";
import {LinkOutlined, MessageOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {useState} from "react";
import {SentenceModal} from "./DrugDetailList";

export const DiseaseDetailList = ({ fetchData, isLoading, data, entityType = 'drugs' }) => {
  const scoreColor = '#108ee9'
  const [showSentence, setShowSentence] = useState(false)
  const [sentence, setSentence] = useState()

  const columns = [
    {
      key: 'drug',
      dataIndex: 'drug',
      title: 'Drug',
      render: item => <Link to={`/${entityType}/${item}`}>{item}</Link>,
      sorter: (a, b) => a.drug.localeCompare(b.drug)
    },
    {
      key: 'class',
      dataIndex: 'class',
      title: 'Class',
      render: item => <Tag color={item === 'Positive' ? 'success' : item === 'Negative' ? 'error' : 'processing'}>{item}</Tag>,
      filters: [
        {
          text: 'Positive',
          value: 'Positive',
        },
        {
          text: 'Negative',
          value: 'Negative',
        },
      ],
      onFilter: (value, record) => record.class.indexOf(value) === 0,
    },
    {
      key: 'confidence',
      dataIndex: 'confidence',
      title: 'Confidence',
      render: item => <Tag color={scoreColor}>{item}%</Tag>,
      sorter: (a, b) => a.confidence - b.confidence
    },
    {
      key: 'actions',
      title: 'Actions',
      render: (item, record) => <Space>
        <Button onClick={() => {
          setSentence(record.id)
          setShowSentence(true)
        }} icon={<MessageOutlined />} />
        <Button target="_blank" href={`https://go.drugbank.com/unearth/q?searcher=drugs&query=${record.drug}`} icon={<LinkOutlined />} />
      </Space>
    }
  ]

  const headers = [
    { label: 'Drug', key: 'drug' },
    { label: 'Disease', key: 'disease' },
    { label: 'Confidence Score', key: 'confidence' },
    { label: 'Class', key: 'class' },
    { label: 'Sentence', key: 'sentence' },
  ]

  const onChange = (pagination, filter, sorter) => {
    fetchData({
      page: pagination.current,
      per_page: pagination.pageSize,
      filter,
      sorter
    })
  }

  return(
    <>
      <Table pagination={{ total: data.total, current: data.current_page, pageSize: data.per_page }} onChange={onChange} scroll={{ x: true }} loading={isLoading} dataSource={data.data} columns={columns} />
      <div style={{ textAlign: 'center' }}><Button type="primary"><CSVLink headers={headers} filename={entityType ? `${entityType}_diseases.csv` : "drug_diseases.csv"} data={data.data}>Download CSV</CSVLink></Button></div>
      <br />
      <SentenceModal id={sentence} showSentence={showSentence} setShowSentence={setShowSentence} />
      {/*<Modal
        title="Sentence(s)"
        visible={showSentence}
        onOk={() => setShowSentence(false)}
        onCancel={() => setShowSentence(false)}
        centered
        destroyOnClose
        width={1000}
      >
        {sentence}
      </Modal>*/}
      {/*<List
        pagination={true}
        size="large"
        loading={isLoading}
        bordered
        dataSource={data}
        footer={<div style={{ textAlign: 'center' }}><Button type="primary"><CSVLink filename="drug_diseases.csv" data={data}>Download CSV</CSVLink></Button></div>}
        renderItem={item => (
          <List.Item
            actions={[<Button onClick={() => {
              setSentence(item.sentence)
              setShowSentence(true)
            }} icon={<MessageOutlined />} />, <Button target="_blank" href={`https://go.drugbank.com/unearth/q?searcher=drugs&query=${item.drug}`} icon={<LinkOutlined />} />]}
          >
            <List.Item.Meta
              avatar={<Avatar style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}>{item.drug[0]}</Avatar>}
              title={<Typography.Title level={4}><Link to={`/drugs/${item.drug}`}>{item.drug}</Link> <Tag color={item.class === 'Positive' ? successColor : item.class === 'Neutral' ? neutralColor : dangerColor}>{item.class}</Tag></Typography.Title>}
              description={<>Confidence Score: <Tag color={scoreColor}>{item.confidence}%</Tag></>}
            />
          </List.Item>
        )}
      />*/}
    </>
  )
}